module.exports = __webpack_public_path__ + "static/media/bg_page21.50a37215.jpg";